import { workflowDrivenCacheActionCreator } from '@ispm/workflow/utils/store.utils';

export const FINDINGS_ACTIONS = {
  'UPDATE': 'FINDINGS_UPDATE',
  'INIT': 'FINDINGS_INIT'
};


export const initActionCreator = workflowDrivenCacheActionCreator(FINDINGS_ACTIONS.INIT);
export const updateActionCreator = workflowDrivenCacheActionCreator(FINDINGS_ACTIONS.UPDATE);
